module.exports = __webpack_public_path__ + "static/media/Bettlaeufer_65x260.8b5ba75f.png";